import React from 'react';
import { Row, Col } from 'grab-ui';
import PageContentPanel from 'components/v2/page-content-panel';
import { ShopContext } from 'views/v2/shopify-home/contexts/shop-context';
import AddressCard from './address-card.jsx';
import ShopAddressSettingsModalContextProvider from './address-card.jsx/shop-address-settings-modal-context';
import styles from './shop-address-settings-section.less';

const ShopAddressSettingsSection = () => {
  const { shop } = React.useContext(ShopContext);
  const { pickUpAddresses } = shop;
  return (
    <PageContentPanel
      className={styles.ShopAddressSettingsForm}
      header="Pick up address"
      message="Your pick up address from Shopify is linked here."
    >
      <Row className={styles.AddressesContainer} type="flex" gutter={16}>
        {pickUpAddresses &&
          pickUpAddresses.map((x, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Col key={i} xs={24} sm={12} md={8}>
              <ShopAddressSettingsModalContextProvider pickUpAddress={x}>
                <AddressCard />
              </ShopAddressSettingsModalContextProvider>
            </Col>
          ))}
      </Row>
    </PageContentPanel>
  );
};

export default ShopAddressSettingsSection;
